// Cantități pentru livrările libere: `buc` doar întregi, altele max 4 zecimale.

export function isWholeUnit(unit: string | null | undefined): boolean {
  return (unit ?? "").trim().toLowerCase() === "buc";
}

/** Rotunjește la max 4 zecimale (backend refuză zgomotul de float, ex. 0.30000000000000004). */
export function roundQty(n: number): number {
  return Math.round(n * 10000) / 10000;
}

export function fmtQty(n: number): string {
  return String(roundQty(n));
}

/** Cantitate validă pentru unitate: > 0, întreagă pentru `buc`. */
export function validQty(n: number | "" | null | undefined, unit: string | null | undefined): n is number {
  if (typeof n !== "number" || !Number.isFinite(n) || n <= 0) return false;
  return !isWholeUnit(unit) || Number.isInteger(n);
}
